import styled from 'styled-components';
import { Badge as AntBadge } from 'antd';
export const Badge = styled(AntBadge) `
  color: inherit;
  font-size: inherit;
  .ant-badge-count {
    min-width: 18px;
    height: 18px;
    line-height: 18px;
    background-color: var(--color-base-red);
    box-shadow: none;
  }

  .ant-badge-dot {
    background: var(--color-base-red);
    box-shadow: none;
  }
`;
